/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_Q2Inputs */

const en_fc_home_faq_q2 = /** @type {(inputs: Fc_Home_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is FilmCraft made by Adobe?`)
};

/**
* | output |
* | --- |
* | "Is FilmCraft made by Adobe?" |
*
* @param {Fc_Home_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_q2 = /** @type {((inputs?: Fc_Home_Faq_Q2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_Q2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_q2(inputs)
});
export { fc_home_faq_q2 as "fc.home.faq.q2" }